var map = {
	"./1/list-pattern1.svg": 876,
	"./1/list-pattern2.svg": 877,
	"./1/list-pattern3.svg": 878,
	"./1/pattern1.svg": 879,
	"./1/pattern2.svg": 880,
	"./1/pattern3.svg": 881,
	"./10/list-pattern1.svg": 882,
	"./10/list-pattern2.svg": 883,
	"./10/list-pattern3.svg": 884,
	"./10/pattern1.svg": 885,
	"./10/pattern2.svg": 886,
	"./10/pattern3.svg": 887,
	"./11/list-pattern1.svg": 888,
	"./11/list-pattern2.svg": 889,
	"./11/list-pattern3.svg": 890,
	"./11/pattern1.svg": 891,
	"./11/pattern2.svg": 892,
	"./11/pattern3.svg": 893,
	"./2/list-pattern1.svg": 894,
	"./2/list-pattern2.svg": 895,
	"./2/list-pattern3.svg": 896,
	"./2/pattern1.svg": 897,
	"./2/pattern2.svg": 898,
	"./2/pattern3.svg": 899,
	"./3/list-pattern1.svg": 900,
	"./3/list-pattern2.svg": 901,
	"./3/list-pattern3.svg": 902,
	"./3/pattern1.svg": 903,
	"./3/pattern2.svg": 904,
	"./3/pattern3.svg": 905,
	"./4/list-pattern1.svg": 906,
	"./4/list-pattern2.svg": 907,
	"./4/list-pattern3.svg": 908,
	"./4/pattern1.svg": 909,
	"./4/pattern2.svg": 910,
	"./4/pattern3.svg": 911,
	"./5/list-pattern1.svg": 912,
	"./5/list-pattern2.svg": 913,
	"./5/list-pattern3.svg": 914,
	"./5/pattern1.svg": 915,
	"./5/pattern2.svg": 916,
	"./5/pattern3.svg": 917,
	"./6/list-pattern1.svg": 918,
	"./6/list-pattern2.svg": 919,
	"./6/list-pattern3.svg": 920,
	"./6/pattern1.svg": 921,
	"./6/pattern2.svg": 922,
	"./6/pattern3.svg": 923,
	"./7/list-pattern1.svg": 924,
	"./7/list-pattern2.svg": 925,
	"./7/list-pattern3.svg": 926,
	"./7/pattern1.svg": 927,
	"./7/pattern2.svg": 928,
	"./7/pattern3.svg": 929,
	"./8/list-pattern1.svg": 930,
	"./8/list-pattern2.svg": 931,
	"./8/list-pattern3.svg": 932,
	"./8/pattern1.svg": 933,
	"./8/pattern2.svg": 934,
	"./8/pattern3.svg": 935,
	"./9/list-pattern1.svg": 936,
	"./9/list-pattern2.svg": 937,
	"./9/list-pattern3.svg": 938,
	"./9/pattern1.svg": 939,
	"./9/pattern2.svg": 940,
	"./9/pattern3.svg": 941,
	"./99/list-pattern1.svg": 942,
	"./99/pattern1.svg": 943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 983;